import { render, staticRenderFns } from "./super-table.vue?vue&type=template&id=24b7f176&scoped=true&"
import script from "./super-table.vue?vue&type=script&lang=js&"
export * from "./super-table.vue?vue&type=script&lang=js&"
import style0 from "./super-table.vue?vue&type=style&index=0&id=24b7f176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7f176",
  null
  
)

export default component.exports